import { ReactNode } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BaseTopUpRequest from "../RaiseETopUpRequest/BaseTopUpRequest";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import AddManualEntry from "../AddManualEntry";

interface StockTransferProps {
  children?: ReactNode;
}

const StockTransfer = ({ children }: StockTransferProps) => {
  const { tab } = useParams();
  const navigate = useNavigate();

  if (tab === "add-manual-entry") {
    return (
      <div>
        <Breadcrumbs
          navPath={["Services", "Stock Transfer", "Add Manual Entry"]}
          heading="Add Manual Entry"
          links={["/services/recharge", "/services/stock-transfer"]}
        />
        <AddManualEntry />
      </div>
    );
  }

  return (
    <div>
      <Breadcrumbs
        navPath={["Services", "Stock Transfer"]}
        heading="Stock Transfer"
        links={["/services/recharge"]}
        noNavigation
        list={true}
        button={{
          buttonName: "Add Manual Entry",
          className: "w-[180px]",
          buttonOnclick: () => navigate("/services/stock-transfer/add-manual-entry"),
        }}
      />
      <BaseTopUpRequest
        showWalletSelection={true}
        showPaymentTypeSelection={false}
        defaultPaymentType="stock_transfer"
        useNestedDropdown={true}
      >
        {children}
      </BaseTopUpRequest>
    </div>
  );
};

export default StockTransfer;
